import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const ReadAboutButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: ${size(3)} 0;

  & ~ & {
    border-top: 1px solid ${theme.colors.border.main};
  }

  svg {
    font-size: 24px;
  }
`;

export const Label = styled.span`
  flex-grow: 1;
  font-weight: 600;

  ${theme.screens.Lg} {
    font-size: 20px;
  }
`;
